import React from "react";
import { Label, Input } from "../StyledComponents/StyledComponents";

function EditorInput(props) {
  let incoming_value = props.value;
  if (incoming_value == null) {
    incoming_value = "";
  }
  return (
    <>
      {props.label && (
        <Label>
          {props.label}
          {props && props.delete && (
            <img
              src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/trash.svg`}
              alt="trash"
              className="delete_icon"
              onClick={() => props.onDelete(props.name, props.sectionId)}
              style={{ marginTop: "-2px" }}
            />
          )}
        </Label>
      )}
      <Input type="text" value={incoming_value} {...props} />
    </>
  );
}

export default EditorInput;
